import React from 'react'
import { useTranslation } from 'next-i18next'

import CommonButton from '@/components/form/Button/CommonButton'

interface Props {
  open: boolean
  short?: boolean
}

function Burger(props: Props) {
  const { open, short = false } = props
  const { t } = useTranslation('common')

  return (
    <CommonButton
      variant="icon"
      open={open}
      short={short}
      aria-label={open ? t('a11y.burgerClose') : t('a11y.burgerOpen')}
      aria-expanded={open}
      data-test-id="burger-menu"
      size="S"
    />
  )
}

export default Burger
